import { createContext, useContext } from 'react';

export const defaultValue = {
  whitelabelURL: window.Hivebrite?.donation?.whitelabelURL, // global variable set here app/views/layouts/_javascripts.html.haml
};

const DonationContext = createContext(defaultValue);

export const useDonationContext = () => useContext(DonationContext);

export const withDonationContext = (Component) => (props) => {
  const contextValue = useDonationContext();

  return <Component {...props} {...contextValue} />;
};

export default DonationContext;
